// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
// import Vuex from 'vuex'
import Vuetify from 'vuetify'
import colors from 'vuetify/es5/util/colors'
import 'vuetify/dist/vuetify.min.css'
import VuetifyConfirm from 'vuetify-confirm'
// import 'vuetify-rtl-style/dist/css/vuetify-rtl-style.min.css'
import VueClipboard from 'vue-clipboard2'
import '@mdi/font/css/materialdesignicons.css'

import VueI18n from 'vue-i18n';
import messages from './i18n/messages';
Vue.use(VueI18n);

import * as firebase from 'firebase/app';
import 'firebase/auth';
import firebaseConfig from './firebaseConfig';
firebase.initializeApp(firebaseConfig)

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'he',
  messages,
})

import VueSocketIO from 'vue-socket.io';
Vue.use(new VueSocketIO({
  debug: process.env.NODE_ENV === 'development',
  connection: process.env.SERVER_BASE_URL,
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  }
}));

import VueSplit from 'vue-split-panel'
Vue.use(VueSplit)

Vue.use(require('vue-shortkey'));

import { EventBus } from './event-bus.js';
Vue.prototype.$bus = EventBus;

Vue.use(Vuetify, {
  rtl: true,
  theme: {
    primary: colors.blue.darken3,
    secondary: colors.red.darken2
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
})

Vue.use(VueClipboard)

Vue.use(VuetifyConfirm, {
  buttonTrueText: 'כן',
  buttonFalseText: 'לא',
  width: 300,
  property: '$confirm'
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js